<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-primary">
              <strong>Inventory Items</strong>
            </h4>
          </template>
          <template v-slot:headerAction>
            <div class="d-flex align-items-center gap-4 float-right">
              <a class="text-primary mr-4" role="button" style="cursor: pointer" @click="openInventoryMaster">
                <i class="fa fa-home mr-2" />
                <span>Masters Inventory</span>
              </a>
              <a class="text-primary mr-4" role="button" style="cursor: pointer" @click="onExportItem">
                <i class="fa fa-file-excel mr-2" />
                <span>Export Data</span>
              </a>
              <a class="text-primary mr-4" role="button" style="cursor: pointer" @click="openslideFormItem('ADD', null)" v-if="addPermission">
                <i class="fa fa-plus mr-2" />
                <span>Create Data</span>
              </a>
            </div>
          </template>
          <template v-slot:body>
            <!-- FILTERING ItemS -->
            <b-row class="mb-4">
              <b-col md="3">
                <b-form-group label="Search" label-for="search" v-model="params.search">
                  <b-form-input
                    type="text"
                    placeholder="Search ID/Name..."
                    v-model="params.search"
                    name="search"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group label="Filter" label-for="button_search">
                  <b-button
                    @click="getListItem"
                    type="button"
                    variant="primary"
                    ><i class="fa fa-filter"></i
                  ></b-button>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- TABLE CONTENT -->
            <b-row>
              <b-col md="12">
                <div v-if="loading" class="alert alert-info">Loading...</div>
                <iq-card> 
                  <div class="overflow-auto d-flex" v-if="list?.data?.length > 0">
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th class="text-center" style="width: 20px">No</th>
                          <th class="text-center text-truncate">Kode Barang</th>
                          <th class="text-center text-truncate">Nama Barang</th>
                          <th class="text-center text-truncate">Kategory Barang</th>
                          <th class="text-center text-truncate">Informasi Spesifikasi</th>
                          <th class="text-center text-truncate">For Vehicle Type</th>
                          <th class="text-center text-truncate">Image</th>
                          <th class="text-center text-truncate">File</th>
                          <th class="text-center" style="width: 20px">#</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(state, index) in list.data" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td class="text-truncate">{{ state?.code }}</td>
                          <td class="text-truncate">{{ state?.name }}</td>
                          <td class="text-truncate">{{ state?.category?.name }}</td>
                          <td class="text-truncate">{{ state?.spesification?.name }}</td>
                          <td class="text-truncate text-center">
                            <div class="d-flex flex-wrap" v-if="state?.vehicleTypeItem?.length > 0">
                              <b-badge variant="primary" v-for="(obj, objIndex) in state?.vehicleTypeItem" :key="objIndex" class="mr-2 mb-2">
                                {{ obj?.vehicleType?.name }}
                              </b-badge>
                            </div>
                            <span v-else>-</span>
                          </td>
                          <td class="text-center">
                            <img 
                              :src="`${state?.file}`" 
                              :key="index + '-file'"
                              alt="img" 
                              height="30px"
                              style="cursor:pointer"
                            />
                          </td>
                          <td class="text-center text-primary"><i class="fa fa-file" style="cursor:pointer" @click="handleOpenFilePreview(`${state?.file}`)" /></td>
                          <td v-if="updatePermission || deletePermission">
                            <div class="d-flex align-items-center">
                              <i class="fa fa-pen text-primary mr-3" style="cursor: pointer;" @click="openslideFormItem('EDIT', state?.id)" />
                              <i class="fa fa-trash text-danger" style="cursor: pointer;" @click="onDeleteItem(state)" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="mt-3" v-if="list?.data?.length > 0">
                    <b-pagination
                      v-model="params.page"
                      :total-rows="list?.meta?.totalItem"
                      @change="getListItem"
                      :per-page="list?.meta?.perPage"
                      first-number
                      align="center"
                    ></b-pagination>
                  </div>
                  <p v-else class="text-center my-4">No Items data found.</p>
                </iq-card>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>

      <b-col lg="12">
        <b-sidebar v-model="slideFormItem" id="form-item" :title="`${action} Items`" width="100%" backdrop-variant="dark" bg-variant="white" right backdrop shadow>
          <template #default="{hide}">
            <b-row class="m-3">
              <b-col cols="12">
                <fieldset class="form-group border p-3">
                    <legend class="w-auto px-2 text-primary">Inventory Items</legend>
                    <b-row class="mt-2">
                      <b-col md="12">
                        <FormItem 
                          :action="action" 
                          :edit-id="editId" 
                          :refresh-data="refreshData" 
                          :closeslideFormItem="closeslideFormItem" 
                          :optionsUnit="optionsUnit" 
                          :optionsSpesification="optionsSpesification" 
                          :optionsCategory="optionsCategory" 
                        />
                      </b-col>
                    </b-row>
                </fieldset>
              </b-col>
            </b-row>
            </template>
        </b-sidebar>
      </b-col>

      <b-col lg="12">
        <b-sidebar v-model="showInventoryMaster" id="inventory-master" :title="`INVENTORY MASTERS`"  width="100%" backdrop-variant="dark" bg-variant="white" right backdrop shadow>
          <template #default="{hide}">
              <b-row class="m-3">
                <b-col cols="12">
                  <fieldset class="form-group border p-3">
                    <legend class="w-auto px-2 text-primary">Inventory Masters</legend>
                      <b-row class="mt-2">
                          <b-col md="12">
                            <ContentInventoryMaster :refreshMasterData="refreshMasterData"  />
                          </b-col>
                      </b-row>
                  </fieldset>
                </b-col>
              </b-row>
            </template>
        </b-sidebar>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import _ from 'lodash'
  import { createPopper } from '@popperjs/core'
  import moment from 'moment'
  import FormItem from './FormItem.vue'
  import ContentInventoryMaster from './ContentInventoryMaster.vue'
  import { busdevActions, fleetsActions } from '@src/Utils/helper'

  export default {
    name: 'Item',
    data() {
      return {
        apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,

        exporting:false,
        loading:false,

        slideFormItem:false,

        optionsUnit: [], 
        optionsSpesification: [], 
        optionsCategory: [],

        action:'',
        editId:null,

        params:{
          page: 1,
          perPage:25,
          search:'',
        },

        list: {
          data:[],
          meta:null
        },
      }
    },
    components:{
      FormItem,
      ContentInventoryMaster,
    },
    watch: {},
    computed: {
      addPermission(){
        let hasAccess = true
        // let hasAccess = JSON.parse(localStorage.getItem('profile')).menu
        //   .find(obj => obj.menu === 'Apps').child
        //   .find(obj => obj.menu === 'Business Development').child
        //   .find(obj => obj.menu === 'Busdev Item').add

        return hasAccess
      },
      updatePermission(){
        let hasAccess = true
        // let hasAccess = JSON.parse(localStorage.getItem('profile')).menu
        //   .find(obj => obj.menu === 'Apps').child
        //   .find(obj => obj.menu === 'Business Development').child
        //   .find(obj => obj.menu === 'Busdev Item').update

        return hasAccess
      },
      deletePermission(){
        let hasAccess = true
        // let hasAccess = JSON.parse(localStorage.getItem('profile')).menu
        //   .find(obj => obj.menu === 'Apps').child
        //   .find(obj => obj.menu === 'Business Development').child
        //   .find(obj => obj.menu === 'Busdev Item').delete

        return hasAccess
      },
    },
    async mounted() {
      this.getOptionsSpesification()
      this.getOptionsCategory()
      this.getOptionsUnit()

      this.getListItem()
    },
    created () {
      // this.getListItem = _.debounce(this.getListItem, 500)
    },
    methods: {
      ...busdevActions,
      ...fleetsActions,
      refreshData(){
        this.getListItem()
      },
      refreshMasterData(){
        this.getOptionsSpesification()
        this.getOptionsCategory()
      },
      openInventoryMaster(action, id){
        this.showInventoryMaster = true
        this.$root.$emit('bv::toggle::collapse', `inventory-master`)
      }, 
      openslideFormItem(action, id){
        this.action = action
        this.editId = id || null

        this.slideFormItem = true
        this.$root.$emit('bv::toggle::collapse', `form-item`)
      },
      closeslideFormItem(){
        this.action = ''
        this.editId = null

        this.slideFormItem = true
        this.$root.$emit('bv::toggle::collapse', `form-item`)
      }, 
      refreshData(){
        this.slideFormItem = false
        this.$root.$emit('bv::toggle::collapse', `form-item`)

        this.getListItem()
      },
      handleOpenFilePreview: function (url) {
        window.open(`${this.apiUrl}/${url}`, "_blank");
      },
      async getOptionsUnit() {
        this.optionsUnit = []
        let res = await this.fetchUnit()
        if (res.data.status === true) {
          this.optionsUnit = res.data.data
        }
      },
      async getOptionsCategory() {
        this.optionsCategory = []
        let res = await this.fetchMaterialCategory()
        if (res.data.status === true) {
          this.optionsCategory = res.data.data
        }
      },
      async getOptionsSpesification() {
        this.optionsSpesification = []
        let res = await this.fetchSpesification()
        if (res.data.status === true) {
          this.optionsSpesification = res.data.data
        }
      },
      
      async getListItem(page) {
        let params = {
          page: page || 1,
          ...this.params,
        }

        if(!params.search) delete params.search

        let res = await this.fetchInventoryItem(params)
        console.log(res, "res")

        if (res.status === 'success' && res.data.data.length > 0) {
          this.list.data = res.data?.data
          this.list.meta = res.data?.meta
        } else {
          this.list.data = []
          this.list.meta = null
        }
      },
      async onExportItem() {
        this.exporting = true
        try {
          let params = {
            ...this.params,
          }

          if(!params.search) delete params.search

          let res = await this.exportInventoryItem(params)

          saveAs(res.data, 'List Items.xlsx')
        } catch (error) {
          this.$swal(
            'Failed Export!',
            'Something went wrong.',
            'error'
          ) 
        }

        this.exporting = false
      },

      async onDeleteItem(data){
        this.$swal({
            title: `Are you sure want to delete Item Code ${data?.code} ?`,
            text: "Yes, i'm sure.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
              const res = await this.deleteInventoryItem({id:data.id})

              if(res?.data?.status === false || res?.data?.code === 400){
                  this.$swal(
                      'Failed!',
                      res?.data?.message,
                      'error'
                  )
                  return 
              } 

              await this.getListItem()
              this.$swal(
                  'Success!',
                  'Success delete Item.',
                  'success'
              )
            }
        })
      },
    }
  }
</script>